import useApplyVideoObjectFit from '@hooks/ref/useApplyVideoObjectFit';
import type { BaseComponentProps } from '@interfaces/selection';
import { useAudioVideo } from '@providers/AudioVideoProvider';
import { useLocalVideo } from '@providers/LocalVideoProvider';
import type { FC, PropsWithChildren } from 'react';
import { useEffect, useRef } from 'react';
import { Container } from './style';

interface MyRemoteVideo extends BaseComponentProps {
  nameplate?: string;
}

const MyRemoteVideo: FC<PropsWithChildren<MyRemoteVideo>> = ({ ...rest }) => {
  const { tileId, isVideoEnabled } = useLocalVideo();
  const audioVideo = useAudioVideo();
  const videoEl = useRef<HTMLVideoElement | null>(null);
  useApplyVideoObjectFit(videoEl);

  useEffect(() => {
    if (!audioVideo || !tileId || !videoEl.current || !isVideoEnabled) {
      return;
    }

    audioVideo.bindVideoElement(tileId, videoEl.current!);

    return () => {
      const tile = audioVideo.getVideoTile(tileId);
      if (tile) {
        audioVideo.unbindVideoElement(tileId);
      }
    };
  }, [audioVideo, tileId, isVideoEnabled]);

  // 내 타일은 구독할 참석자 ID 가 없어 빈 값을 넘긴다.
  return (
    <Container {...rest} ref={videoEl} attendeeId='' videoTileType={'my'} />
  );
};

export default MyRemoteVideo;
